module.exports = __webpack_public_path__ + "static/sterling_737x621-050acdc99541213fea1961173bbe9e30.png";